import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Core2Config } from '../shared';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { HcPatientHdrContainerModel } from '../../../../../models/aggregates/healthcare/patient_hdr_container.model';

@Injectable({ providedIn: 'root' })
export class HcPatientHdrService extends BaseApiTemplateService<HcPatientHdrContainerModel> {
    readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + "patient-hdrs";

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + 'patient-hdrs' + '/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + 'patient-hdrs' + '/backoffice-ep';
        this.httpClient = http;
    }
}